import {Badge} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {alpha, css, styled} from '@mui/material/styles';

const isHapTheme = (themeName: string) => themeName === 'hap';

const StyledNotificationsButton = styled(IconButton)`
	${({theme}) => {
		const hap = isHapTheme(theme.name);

		return css`
			background-color: ${alpha(theme.palette.common.white, 0.16)};
			&:is(&, :active, :focus) {
				background-color: ${alpha(theme.palette.common.white, 0.16)};
				color: ${hap ? theme.palette.common.white : theme.palette.common.black};
			}
		`;
	}}
`;

const StyledBadge = styled(Badge)`
	& .MuiBadge-badge {
		min-width: 14px;
		height: 14px;
		line-height: inherit;
		font-size: 9px;
	}
`;

export {StyledNotificationsButton, StyledBadge};
